const CustomInput = ({ id , label, name, disabled = false, type = 'text', placeholder = '', required = false, readOnly = false, isLtr = false, maxLength = '', min = '', max = '',onchange = () => {}, accept = '*' }) => {
    return (
        <div className="form-group">
            <label>{label}</label>
            <input
                type={type}
                name={name}
                id={id}
                className={`form-control ${id === "" ? ' is-invalid' : ''}`}
                required={required}
                readOnly={readOnly}
                maxLength={maxLength}
                placeholder={placeholder}
                disabled={disabled}
                max={max}
                min={min}
                accept={accept}
                onChange={onchange} />
        </div>
    );
}

export default CustomInput;